import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { isSupported } from 'twilio-video';
import UnavailableRoom from "../components/rooms/unavailable_room";
import PreviewRoom from "../components/rooms/preview_room";
import PreloadRoom from "../components/rooms/preload_room";
import VideoConference from "../components/rooms/video_conference";
import ClosedRoom from "../components/rooms/closed_room";

class EmptyRoom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      is_available: null,
      connected: false,
      room_evaluation: false,
      room: null,
      holderToken: null,
    };
    this.isSupported = true;
    this.deviceOrigin = (typeof(window["ReactNativeWebView"]) !== "undefined") ? 'native' : 'web';
    console.log(this.isSupported);
    console.log(this.deviceOrigin);
  }

  render() {
      return(<ClosedRoom holder={this.props.holder} appointment={this.props.appointment} roomToken={this.props.token} site={this.props.site}/>)
  }
}


export default EmptyRoom;
